const Footer = () => {
    return (
        <footer>
            Помогите своему ребёнку сдать ЕГЭ по английскому на высокий балл!
        </footer>
    );
}

export default Footer;
